import * as Actions from '../actions/actions'

export default class Mutators {
	constructor(settings) {
		this._settings = settings;

		try {
            this._$ = require('jquery').noConflict(true);
            require('jquery-ui/ui/widgets/draggable');
        } catch (e) {
			console.error(`DragWindow.Mutators error: ${e}`)
        }
	}

	initialize(store) {
		this._store = store;
		this._state = store.getState();
	}

	getMutate() {
		return (parameters) => {
			let self = this;
			let $ = this._$;

			let gutterPixels = this._settings.Window.gutterSize != null ? 
							   this._settings.Window.gutterSize :
							   15;

			let DragHook = () => {};
			DragHook.prototype.hook = (node, propertyName, previousValue) => {
				let draggableOptions = {
					handle: `.${this._settings.classNames.headerClassName}`,
					cancel: `.${this._settings.classNames.minimizeClassName}`,
					scroll: false,
					opacity: 0.5,
					snap: false,
					snapMode: 'inner',
					snapTolerance: 30,
					start: onStart,
					stop: onEnd,
					iframeFix: true
				};

				let optionsFromSettings = this._settings.Drag || {};
				draggableOptions = Object.assign(draggableOptions, optionsFromSettings);
				
				//AKA-3905 The element wasn't getting added fast enough on refresh
				//tries to get the draggable element a few times before giving up
				let $draggableElement = $(`.${this._settings.classNames.windowClassName}`);
				let x=0;
				let promise = new Promise((resolve, reject) => {
					var intervalID = setInterval(function () {
						$draggableElement = $(`.${this._settings.classNames.windowClassName}`);

						if($draggableElement || x === 5){
							window.clearInterval(intervalID);
							resolve();
						}
						x++;
					}.bind(this), 500);
				});

				promise.then(() => {
					// Setting up draggable on element not in DOM may set its
					// position to relative - bail instead.
					// https://stackoverflow.com/a/20502071
					// Also need to check whether draggable has already been set up.
					if (!$draggableElement || 
						!$draggableElement[0] || 
						getComputedStyle($draggableElement[0]).position === 'static' ||
						$draggableElement.hasClass('ui-draggable')
					)
						return;

					$draggableElement.draggable(draggableOptions);
					$draggableElement.draggable('enable');	
					
					let getVertScrollBarWidth = function(){
						if(document.body){
							return window.innerWidth - document.body.scrollWidth;
						}
						else{
							return 0;
						}
					}
					
					$draggableElement.on('mouseover', function() {
						let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
						let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

						let container = [
							$(document).scrollLeft() + gutterPixels,
							$(document).scrollTop() + gutterPixels,
							$(document).scrollLeft() + (windowWidth - (gutterPixels + getVertScrollBarWidth())) - $(this).outerWidth(),
							$(document).scrollTop() + (windowHeight - gutterPixels) - $(this).outerHeight()
						];

						$(this).draggable('option', 'containment', container);
					});
				});
			};
			
			let onStart = (event, ui) => {
				let isDraggingStateLoc = this._settings.stateLocations.Window.isDragging;
				this._store.dispatch(Actions.startDragWindow(isDraggingStateLoc));
			};
			
			let onEnd = (event, ui) => {
				let isDraggingStateLoc = this._settings.stateLocations.Window.isDragging;
				let positionStateLoc = this._settings.stateLocations.Window.position;

				let newPos = {
					xPos: ui.position.left,
					yPos: ui.position.top
				};

				// fix for running interact resize and jquery drag at the same time, causes cursors to override each other
				document.body.style.cursor = '';

				this._store.dispatch(Actions.endDragWindow(isDraggingStateLoc, positionStateLoc, newPos));
			};
			
			let dragBehavior = {
				drag: new DragHook()
			};

			return Object.assign({}, parameters, dragBehavior);
		}
	}
	
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-drag/src/renderers/mutator.js